<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange(page)"
        @search-reset="searchClear"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="success"
            size="small"
            icon="el-icon-success"
            plain
            @click.stop="handleRegister()"
          >注册</el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-circle-plus"
            plain
            @click.stop="handleAdd(scope.row,scope.index)"
          >新增绑定</el-button>
          <el-button
            type="danger"
            size="small"
            icon="el-icon-error"
            plain
            @click.stop="handleDel(scope.row,scope.index)"
          >批量解除绑定</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="danger"
            size="small"
            icon="el-icon-close"
            plain
            @click.stop="handleDel(scope.row,scope.index)"
          >解除绑定</el-button>
        </template>

        <template
          slot-scope="scope"
          slot="findNameForm"
        >
          <!-- <el-select v-model="currClassify" clearable placeholder="请选择系统大类">
            <el-option
              v-for="item in classifySelects"
              :key="item.id"
              :label="item.rootName"
              :value="item.id"
            ></el-option>
          </el-select>-->
          <el-select
            v-model="currClassify"
            filterable
            remote
            reserve-keyword
            placeholder="请输入手机号"
            :remote-method="remoteMethod"
            :loading="loading"
            value-key="id"
          >
            <el-option
              v-for="item in classifySelects"
              :key="item.id"
              :label="item.realName"
              :value="item"
            ></el-option>
          </el-select>
        </template>
      </avue-crud>
      <el-dialog
        title="注册推广员"
        :visible.sync="dialogFormVisible"
        width="50%"
      >
        <el-form
          :model="form"
          style="margin-left:50px"
        >
          <el-form-item
            label="账号："
            :label-width="formLabelWidth"
            style="width:50%"
          >
            <el-input
              v-model="form.account"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="密码："
            :label-width="formLabelWidth"
            style="width:50%"
          >
            <el-input
              v-model="form.password"
              type="password"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="姓名/昵称："
            :label-width="formLabelWidth"
            style="width:50%"
          >
            <el-input
              v-model="form.name"
              placeholder="请输入姓名/昵称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="性别："
            :label-width="formLabelWidth"
            style="width:50%"
          >
            <el-radio
              v-model="form.gender"
              label="MALE"
            >男</el-radio>
            <el-radio
              v-model="form.gender"
              label="FEMALE"
            >女</el-radio>
          </el-form-item>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="registerPromoters"
          >注 册</el-button>
          <el-button @click="dialogFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </basic-container>
  </div>
</template>

<script>
import { bindPromotersOption } from "@/const/salesCloud/bindPromotersOption";
import {
  findbindPromoters,
  addbindPromoters,
  findUserList,
  delbindPromoters,
  bindPromoters
} from "@/api/salesCloud/bindPromoters";

export default {
  name: "bindPromoters",
  data() {
    return {
      tableOption: bindPromotersOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      loading: false,
      dialogFormVisible: false,
      form: { gender: "MALE" },
      formLabelWidth: "120px",
      classifySelects: [],
      currClassify: [],
      tabelObj: {},
      ids: "",
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      }
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {},
  props: [],
  methods: {
    registerPromoters() {
      console.log(this.form);
      addbindPromoters(this.form).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增绑定成功",
            type: "success"
          });
          this.dialogFormVisible = false;
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          this.dialogFormVisible = false;
        }
      });
    },
    handleRegister() {
      this.clean();
      this.dialogFormVisible = true;
    },
    remoteMethod(query) {
      console.log(query.length);
      if (query.length == 11) {
        // this.loading = true;
        setTimeout(() => {
          //   this.loading = false;
          console.log("远程搜索");
          let params = {
            type: "JOINS_PROMOTION_SPECIALIST",
            mobile: query
          };
          findUserList(params).then(res => {
            console.log(res);
            if (res.code == "200") {
              let data = JSON.parse(res.data);
              this.classifySelects = data;
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          });
        }, 200);
      } else {
        this.classifySelects = [];
      }
    },
    clean() {
      this.currClassify = "";
      this.classifySelects = [];
      this.form = {};
    },
    searchClear() {
      this.currClassify = "";
    },
    choseClassifyItem() {
      console.log(this.currClassify);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      console.log(this.page);
      params.page = this.page.currentPage;
      params.size = pageSize;
      params.clientType = "JOINS_ENGINEER";
      this.downloadData = params;
      findbindPromoters(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      params.clientType = "JOINS_ENGINEER";
      this.downloadData = params;
      findbindPromoters(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      params.clientType = "JOINS_ENGINEER";

      console.log(params);
      findbindPromoters(params).then(res => {
        if (res.code != 500) {
          let data = JSON.parse(res.data);
          this.tableData = data.rows;
          this.page = {
            total: data.total,
            currentPage: params.page,
            pageSize: params.size
          };
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
          this.tableData = [];
          console.log(11);
        }
      });
    },
    //eslint-disable-next-line
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      params.clientType = "JOINS_ENGINEER";
      this.downloadData = params;
      console.log(page);
      findbindPromoters(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // this.clean()
      this.clean();
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      // this.clean()
      // this.clientType = this.formatClientType(row.useCustomerType)
      // this.joinsWorkServiceCategory = {id: row.serviceCategoryId}
      // this.choseWorkServiceItem();
      // this.joinsWorkServiceItem = {id: row.serviceItemId}
      // if (row.startTime != null && row.endTime != null) {
      //     let array = []
      //     array.push(row.startTime)
      //     array.push(row.endTime)
      //     row.startTime_endTime = array
      // }
      console.log(row);
      this.clean();
      this.currClassify = row.rootId == 0 ? (row.rootId = "") : row.rootId;
      this.$refs.crud.rowEdit(row, index);
    },

    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        clientType: "JOINS_ENGINEER",
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      this.downloadData = params;
      findbindPromoters(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      console.log(row);
      row.userId = this.currClassify.account;
      if (!this.currClassify) {
        this.$message({
          showClose: true,
          message: "请输入手机号",
          type: "error"
        });
        done();
        return;
      }
      bindPromoters(row.userId).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增绑定成功",
            type: "success"
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          done();
        }
      });
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange(val) {
      let ids = val.map(item => {
        return item.id;
      });
      this.ids = ids.join(",");
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(row) {
      console.log(row);
      let ids = "";
      ids = this.ids;
      if (row) {
        ids = row.id;
        console.log(ids);
        this.$confirm(`您确定解除绑定该推广员吗？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            delbindPromoters(ids)
              .then(res => {
                if (res.code == "200") {
                  this.$message({
                    showClose: true,
                    message: "解除绑定成功",
                    type: "success"
                  });
                  this.handleList();
                } else {
                  this.$message({
                    showClose: true,
                    message: res.message,
                    type: "error"
                  });
                }
              })
              .catch(error => {
                this.loading = false;
                this.$message({
                  showClose: true,
                  message: error,
                  type: "error"
                });
              });
          })
          .catch(() => {});
      } else {
        console.log(ids);
        if (!ids) {
          this.$message({
            showClose: true,
            message: "未选中任何数据",
            type: "error"
          });
          return;
        }
        let length = ids.split(",").length;
        this.$confirm(
          `共选中${length}位工程师，您确定批量解除绑定吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            delbindPromoters(ids)
              .then(res => {
                if (res.code == "200") {
                  this.$message({
                    showClose: true,
                    message: "解除绑定成功",
                    type: "success"
                  });
                  this.handleList();
                } else {
                  this.$message({
                    showClose: true,
                    message: res.message,
                    type: "error"
                  });
                }
              })
              .catch(error => {
                this.loading = false;
                this.$message({
                  showClose: true,
                  message: error,
                  type: "error"
                });
              });
          })
          .catch(() => {});
      }
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      console.log(row.id);
    }
  }
};
</script>

    <style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
